import { localStorageInstance } from '@gem/modules/storage';

function getKeyName(userId: string): string {
  return `is-push-notifications-enabled-for-${userId}`;
}

export function set(userId: string, isPushNotificationsEnabled: boolean): void {
  localStorageInstance.setItem(getKeyName(userId), isPushNotificationsEnabled.toString());
}

export function get(userId: string): boolean {
  const isPushNotificationsEnabled = localStorageInstance.getItem(getKeyName(userId));

  return isPushNotificationsEnabled === null || isPushNotificationsEnabled === 'true';
}

export function remove(userId: string): void {
  return localStorageInstance.removeItem(getKeyName(userId));
}
